import React, {useState} from "react";
import {useForm} from "react-hook-form";
import ShopFields from "./ShopFields";

export default function () {
  const {register, handleSubmit, reset, control, watch} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const shopFields = <ShopFields {...{register, errors, control, data, watch}} />;

  return {
    setErrors,
    shopFields,
    handleSubmit,
    reset,
    setData,
  }
}